
const initialState = {
  draftStudents : localStorage.getItem('draftStudents') ? JSON.parse(localStorage.getItem('draftStudents')) : [],
  maxId: localStorage.getItem('draftStudents') ? JSON.parse(localStorage.getItem('draftStudents')).length + 1 : 1
}

export const student = {
  namespaced: true,
  state: initialState,
  actions: {
    setStudent({ commit }, data) {
      commit('setStudent', data);
    },
    removeStudent({ commit }, data) {
      commit('removeStudent', data);
    },
  },
  mutations: {
    setStudent(state, response) {
      if(response.isNew) {
        state.draftStudents.push(response.data)
        state.maxId++
      } else {
        const studentIndex = state.draftStudents.findIndex(student => student.localId === response.data.localId)
        if(studentIndex > -1) {
          state.draftStudents.splice(studentIndex, 1, response.data) 
        }
      }

      localStorage.removeItem('draftStudents')
      localStorage.setItem('draftStudents', JSON.stringify(state.draftStudents))
      
    },
    removeStudent(state, response) {
      const studentIndex = state.draftStudents.findIndex(student => student.localId === response.localId)

      if(studentIndex > -1) {
        state.draftStudents.splice(studentIndex, 1)
        state.maxId--
      }

      localStorage.setItem('draftStudents', JSON.stringify(state.draftStudents))
    }
  }
};